import { BMButton, BMPrimitives, BMText } from "@traveloka/district-bloom";
import { Image, StyleSheet } from "react-native";
import { ERROR_IMAGE_BASE64 } from "../../../assets/error";
import BMView from "../../../components/View/BMView";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import useSafeCountdown from "../../../hooks/useSafeCountdown";
import { formatMessage } from "../../../utils";

const START_TO_RELOAD = 5;

type Props = {
  onRefresh: () => void;
};

export default function ErrorMultiFactor({ onRefresh }: Props) {
  const { countdown } = useSafeCountdown(START_TO_RELOAD);

  const { CorporateEmailOtp: cr } = useMobileContentResource();
  return (
    <BMView style={styles.wrapper} align="center" justify="center" spacing="lg">
      <Image
        style={styles.image}
        source={{ uri: ERROR_IMAGE_BASE64 }}
        alt="Error Image"
      />
      <BMText variant="titleSmall">{cr.mfaGatewayErrorTitle}</BMText>
      <BMText variant="paragraphNormal" style={styles.textAlignCenter}>
        {formatMessage(cr.mfaGatewayErrorDescription, {
          sec: countdown.sec,
        })}
      </BMText>
      {countdown.sec <= 0 && (
        <BMButton
          size="LARGE"
          label={cr.mfaGatewayErrorButtonText}
          onPress={window.location.reload}
          stretchable
        />
      )}
    </BMView>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    width: "100%",
    paddingHorizontal: BMPrimitives.BMSize.xl2,
  },
  image: {
    width: 120,
    height: 120,
  },
  textAlignCenter: {
    textAlign: "center",
  },
});
